<template>
  <div class="insights-benchmarks-averages-toggle">
    <section class="toggle-wrapper">
      <AppSwitch
        :disabled="isLoading"
        :value="showBenchmarksAverages"
        @change="onSwitchChange"
      >
        Benchmarks
      </AppSwitch>
      <template v-if="showBenchmarksAverages">
        <div
          v-if="isLoading"
          class="toggle-loading"
        ></div>
        <template v-else>
          <span
            v-for="legendItem in benchmarksAveragesLegend"
            :key="legendItem.key"
            class="legend-label ml-10"
          >
            <i
              :class="getIconClass(legendItem)"
              class="hi shape"
            />
            {{ buildLegendItemCopy(legendItem) }}
          </span>
        </template>
      </template>
    </section>
    <div
      v-if="hasCurrentUser && 'occupation' in benchmarksAveragesLegendRaw"
      class="job-type-info"
    >
      <template v-if="(currentUserRole === 'owner' || currentUserRole === 'manager') && !hasJobTypeAssigned">
        <i class="hi hi-info-filled"></i>
        <a :href="memberProfileURL">Assign a job type</a>
        <span> to this member to view metrics compared against peers' benchmark.</span>
      </template>
      <template v-if="currentUserRole === 'user' && !hasJobTypeAssigned">
        <i class="hi hi-info-filled mr-5"></i>
        Job type benchmark hidden because this member has no job type assigned.
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import AppSwitch from '~/components/AppSwitch.vue';
import { applyTemplate } from '~/utils/url_template';
import { MEMBER_URL } from '~/app_constants';
import { InsightsTracking } from '~/mixins';

export default {
  name: 'InsightsBenchmarksAveragesToggle',
  components: {
    AppSwitch,
  },
  mixins: [InsightsTracking],
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      benchmarksAveragesLegendRaw: (state) => state.benchmarksAveragesLegend,
      hasOccupation: (state) => state.current_user_has_occupation,
    }),
    ...mapGetters([
      'benchmarksAveragesLegend',
      'showBenchmarksAverages',
      'currentUserRole',
      'currentDashboardUser',
      'organizationId',
    ]),
    memberProfileURL() {
      return applyTemplate(`${MEMBER_URL}?tab=employment`, {
        organizationId: this.organizationId,
        memberId: this.currentDashboardUser?.id,
      });
    },
    hasJobTypeAssigned() {
      return this.benchmarksAveragesLegendRaw?.occupation?.name;
    },
    hasCurrentUser() {
      return this.currentDashboardUser?.id;
    },
  },
  methods: {
    ...mapActions(['setShowBenchmarksAverages']),
    onSwitchChange(val) {
      this.setShowBenchmarksAverages(val);
      this.trackAnalytics('Insights benchmarks change', { new_value: val ? 'On' : 'Off' });
    },
    getIconClass(legendItem) {
      return `insights-benchmarks-averages-color-${legendItem.key}`;
    },
    buildLegendItemCopy(legendItem) {
      if (['organization', 'occupation'].includes(legendItem.key)) {
        return `${legendItem.name}'s average`;
      }

      return `${legendItem.name} Industry average`;
    },
  },
};
</script>
